/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import breakpointsMinWidth from '@styling/breakpointsMinWidth';
import SignIn from './signIn';
import SignUp from './signUp';

import {
  isValidSignUp,
  handleSignUp,
  fetchQueryParams,
  isNotValidName,
  isValidEmail,
  isNotEmpty,
} from '../../signUp/handleSignUp';
import { handleLogin, PostSignInCalls } from '../../signIn/handleSignIn';
import Actions from '../../../store/actions';
import route from '../../../constants/route';
import breakpoints from '../../../styling/breakpoints';
import {
  PrimaryDark,
  HeadingFG,
  grayShade1,
  white,
} from '../../../styling/theme';

const ContainerDiv = styled.div`
  height: fit-content;
  background-color: ${white};
  border-radius: 4px;
  grid-column: 3 / span 3;
  grid-template-columns: repeat(12, 1fr);
  @media ${breakpoints.desktopMd} {
    grid-column: 2 / span 5;
  }
  @media ${breakpoints.tabletLg} {
    grid-column: 2 / span 5;
  }
  @media ${breakpoints.tabletSm} {
    grid-column: 1 / span 7;
    margin-bottom: 9px;
  }
  @media ${breakpoints.mobileSm} {
    grid-column: 1 / span 7;
    margin-bottom: 9px;
  }
`;

export const ButtonDiv = styled.div`
  text-align: center;
  cursor: pointer;
  margin: 0 0 0 0;
  @media ${breakpointsMinWidth.tabletSm} {
    margin: 8px 0 0 0;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    margin: 16px 0 0 0;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    margin: 24px 0 0 0;
  }
`;

export const Input = styled.input`
  color: ${HeadingFG};

  width: 100%;
  height: 44px;

  background: ${white};

  border: ${(props) =>
    props.displayError ? `1px solid #EB5757` : `1px solid ${grayShade1}`};

  box-shadow: ${(props) =>
    props.displayError ? `0 0 4px 0 rgba(235, 87, 87, 0.3)` : `none`};
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 14px;
  :focus {
    outline: none;
    box-shadow: 0 0 4px 0 rgba(71, 56, 128, 0.3);
    border: 1px solid ${PrimaryDark};
  }

  &:focus {
    outline-style: none;
    border: 1px solid ${PrimaryDark};

    box-shadow: 0 0 4px 0 rgba(71, 56, 128, 0.3);
  }
  &:focus + div {
    top: 0;
    color: ${PrimaryDark};
    background: ${white};
    border-radius: 4px;
    padding: 0px;
    left: 14px;
    transition: all 0.2s ease;
  }
`;
export const ErrorSpan = styled.span`
  font-size: 12px;
  color: ${(props) => props.color || 'red'};
`;

class SignInSignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValidPassword: true,
      firstName: '',
      lastName: '',
      preferredUsername: '',
      signUpEmail: '',
      signUpPassword: '',
      successfullySignedUp: false,
      email: '',
      password: '',
      showLoading: false,
      isLoggedIn: false,
      referrerId: '',
      repeatPassword: '',
      isFirstNameValid: true,
      isLastNameValid: true,
      isSignUpEmailValid: true,
      couponsAndDeals: true,
      errorMessage: '',
    };
  }

  componentDidMount = () => {
    const { user } = this.props;

    if (user.token) {
      this.setState({ isLoggedIn: true });
    }
  };

  handleChange = (e, key) => {
    this.setState(
      {
        [key]: e.target.value,
      },
      () => {
        this.checkValidInput(key);
      },
    );
  };

  handleCheckBox = (e, key) => {
    this.setState((state) => ({ [key]: !state[key] }));
  };

  handleLocalLogin = async () => {
    localStorage.setItem('sign-in-method', 'local');
    await this.handleLogin();
  };

  handleLogin = async (e, signup) => {
    const { showLoading } = this.state;
    const { email, password } = this.state;
    const { updateUser } = this.props;
    if (showLoading || !email || !password) return;
    const cleanEmail = email.trim().toLowerCase();
    this.setState({
      showLoading: true,
    });
    let userObj;
    try {
      userObj = await handleLogin(cleanEmail, password, updateUser, signup);
    } catch (err) {
      this.setState({
        showLoading: false,
        errorMessage: err.message,
      });
    }
    if (userObj) {
      this.setState({
        showLoading: false,
        isLoggedIn: true,
        errorMessage: '',
      });
      PostSignInCalls({ ...this.props, user: userObj.user.user });
    }
    this.setState({
      showLoading: false,
    });
  };

  getReferrerIdFromQueryParam = () => {
    const queryArray = fetchQueryParams(this.props);
    const referrerIdIndex = queryArray.indexOf('referrerId');
    if (referrerIdIndex > -1) {
      const referrerId = queryArray[referrerIdIndex + 1];
      this.setState({ referrerId });
    }
  };

  setLocalStorageFromQueryParams = () => {
    const {
      location: { search, pathname },
    } = window;
    localStorage.setItem('rurl', `${pathname}${search}`);
  };

  checkValidInput = (key) => {
    const { signUpEmail, firstName, lastName } = this.state;
    const cleanSignUpEmail = signUpEmail.trim().toLowerCase();
    switch (key) {
      case 'firstName':
        if (!isNotValidName(firstName) || !isNotEmpty(firstName)) {
          this.setState({ isFirstNameValid: false });
        } else {
          this.setState({ isFirstNameValid: true });
        }

        break;
      case 'lastName':
        if (!isNotValidName(lastName) || !isNotEmpty(lastName)) {
          this.setState({ isLastNameValid: false });
        } else {
          this.setState({ isLastNameValid: true });
        }

        break;
      case 'signUpEmail':
        if (!isValidEmail(cleanSignUpEmail) || !isNotEmpty(cleanSignUpEmail)) {
          this.setState({ isSignUpEmailValid: false });
        } else {
          this.setState({ isSignUpEmailValid: true });
        }

        break;
      default:
        break;
    }
  };

  isValidSignUpDetails = () => {
    const {
      firstName,
      lastName,
      isValidPassword,
      signUpPassword,
      signUpEmail,
      repeatPassword,
    } = this.state;
    const cleanSignUpEmail = signUpEmail.trim().toLowerCase();
    return isValidSignUp(
      firstName,
      lastName,
      isValidPassword,
      signUpPassword,
      cleanSignUpEmail,
      repeatPassword,
    );
  };

  defaultRedirectTo = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const signup = searchParams.get('signup');
    let path;
    if (signup) {
      path = route.APPS;
    } else {
      path =
        !localStorage.getItem('rurl') ||
        localStorage.getItem('rurl').split('/signin')[0] === ''
          ? route.APPS
          : localStorage.getItem('rurl');
    }
    return <Redirect to={{ pathname: path }} />;
  };

  handleSignUp = async () => {
    const {
      firstName,
      lastName,
      signUpEmail,
      signUpPassword,
      isValidPassword,
      referrerId,
      repeatPassword,
      couponsAndDeals,
      showLoading,
    } = this.state;
    if (showLoading) return;
    const cleanSignUpEmail = signUpEmail.trim().toLowerCase();
    this.setState({
      showLoading: true,
    });
    const isSignUpSuccess = await handleSignUp(
      firstName.trim(),
      lastName.trim(),
      firstName.trim(),
      isValidPassword,
      signUpPassword,
      cleanSignUpEmail,
      referrerId,
      repeatPassword,
      couponsAndDeals,
    );
    if (isSignUpSuccess) {
      this.setState(
        {
          email: cleanSignUpEmail,
          password: signUpPassword,
          showLoading: false,
        },
        async (e) => {
          await this.handleLogin(e, true);
        },
      );
    } else {
      this.setState({
        showLoading: false,
      });
    }
  };

  successSignUp = () => {
    const { preferredUsername, firstName } = this.state;
    return (
      <Redirect
        to={{
          pathname: '/thankYou',
          state: {
            username:
              preferredUsername.length > 0 ? preferredUsername : firstName,
          },
        }}
      />
    );
  };

  render() {
    const {
      // isLoggedIn,
      email,
      password,
      firstName,
      lastName,
      preferredUsername,
      signUpEmail,
      signUpPassword,
      showLoading,
      successfullySignedUp,
      referrerId,
      repeatPassword,
      isFirstNameValid,
      isLastNameValid,
      isSignUpEmailValid,
      couponsAndDeals,
      errorMessage,
    } = this.state;

    const { currentLabel } = this.props;
    if (successfullySignedUp) {
      return this.successSignUp();
    }

    return (
      <ContainerDiv data-testid="container-signIn">
        {
          {
            Login: (
              <SignIn
                handleLogin={this.handleLogin}
                handleChange={this.handleChange}
                email={email}
                password={password}
                showLoading={showLoading}
                errorMessage={errorMessage}
              />
            ),
            Register: (
              <SignUp
                handleSignUp={this.handleSignUp}
                handleChange={this.handleChange}
                isValidSignUpDetails={this.isValidSignUpDetails}
                firstName={firstName}
                lastName={lastName}
                preferredUsername={preferredUsername}
                signUpEmail={signUpEmail}
                signUpPassword={signUpPassword}
                referrerId={referrerId}
                repeatPassword={repeatPassword}
                getReferrerIdFromQueryParam={this.getReferrerIdFromQueryParam}
                isFirstNameValid={isFirstNameValid}
                isLastNameValid={isLastNameValid}
                isSignUpEmailValid={isSignUpEmailValid}
                showLoading={showLoading}
                couponsAndDeals={couponsAndDeals}
                handleCheckBox={this.handleCheckBox}
              />
            ),
          }[currentLabel]
        }
      </ContainerDiv>
    );
  }
}

SignInSignUp.propTypes = {
  currentLabel: PropTypes.string,
  updateUser: PropTypes.func.isRequired,
  user: PropTypes.object,
};

SignInSignUp.defaultProps = {
  currentLabel: '',
  user: null,
};

const mapDispatchToProps = (dispatch) => ({
  signOut: () => {
    dispatch(Actions.storeUserProfile.signOut());
  },
  updateUser: (...params) => {
    dispatch(Actions.storeUserProfile.updateUser(...params));
  },
  getUserInfo: async (...params) => {
    await dispatch(Actions.userInfoActions.getUserInfo(...params));
  },
  connectWebsocket: (...params) => {
    dispatch(Actions.websocketActions.connectWebsocket(...params));
  },
  addNotifications: (...params) => {
    dispatch(Actions.notificationActions.addNotifications(...params));
  },
  addNewNotification: (...params) => {
    dispatch(Actions.notificationActions.addNewNotification(...params));
  },
});
const mapStateToProps = (state) => ({
  user: state.user,
  webSocket: state.websocket.webSocket,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SignInSignUp));
